
export const Bio = {
    name: "Bhavy Zala",
    roles: [
      "Programmer",
      "MERN Developer",
      "Frontend Developer",
      "UI/UX Designer"
      
    ],
    description:
      "I am a flexible and eager professional who loves learning new things and tackling challenges. I work diligently to deliver excellent results and maintain a positive outlook. With a strong focus on growth and improvement, I am prepared to contribute effectively and achieve significant success. Currently, I am pursuing a degree in Computer Science and Engineering at Nimra University, with a keen interest in web technologies.",
    github: "https://github.com/zalabhavy",
    resume:
      "https://drive.google.com/file/d/1rtGte5NyaptZ3p1mSjaNCkrRsbFM3Fex/view?usp=sharing",
    linkedin: "https://www.instagram.com/nirman.24/",
    insta: "https://www.instagram.com/bhavy_zala499/",
    email: "zalabhavy2004@gmail.com"
  };
  
  export const skills = [
    {
      skills: [
        {
          image: "https://i.postimg.cc/4NnV6trq/DSC-0301.jpg",
        },
        {
          image: "https://i.postimg.cc/j5H0kLBr/IMG-6208.jpg",
        },
        {
          image: "https://i.postimg.cc/dVfgn8Hf/orces.png",
        },
        {
          image: "https://i.postimg.cc/SQ5MWXVT/GCLG5147-1.jpg",
        },
        {
          image: "https://i.postimg.cc/prMVmNMP/IMG-6897-1.jpg",
        },
        {
          image: "https://i.postimg.cc/cLFJX5wc/IMG-6901.jpg",
        },
      ],
    },
  ];

  export const Sponsors = [
    {
      title: "IRA - International Recruitment Academy",
      Sponsor : [
        {
          name : "",
          image : "images/IRA.jpg"
        }
      ],
    },
    {
      title: "Trogon Group",
      Sponsor : [
        {
          name : "",
          image : "images/Trogon.png"
        }
      ],
    }
  ];
  
  
  export const experiences = [
    {
        id: 0,
        img: "https://thumbs.dreamstime.com/b/inauguration-red-waving-ribbon-banner-illustration-design-over-white-31864613.jpg",
        role: "INAUGURATION",
        company: "Venue: C-Audi",
        date: "2:00PM to 3:30PM",
        desc: "The inaugural ceremony will commence with a formal invocation seeking divine blessings. This will be followed by the traditional lighting of the ceremonial lamp by esteemed dignitaries present at the event. This auspicious act will symbolize the commencement of the event and seek blessings for its successful conduct.",
    },
    {
      id: 1,
      img: "https://i.postimg.cc/s29hbVzS/E3.png",
      role: "ARFF MOCK DRILL",
      company: "Venue: Between Dome & AB Lawn",
      date: "Time: 3:45PM to 4:30PM",
      desc: "Awareness regarding fire safety will be provided and a mock drill will be organized for the same.",
  }
  ,{
    id: 2,
    // img: "https://i.postimg.cc/dV35PjCc/quiz.png",
    img: "images/quiz.png",
    role: "Quiz Whiz",
    company: "Online",
    date: "Time: 02:00PM to 05:00PM",
    desc: "This event is a fantastic opportunity to test your knowledge, engage with peers, and showcase your skills in civil engineering. Participants will have the chance to win exciting prizes while deepening their understanding of key concepts in the field.",
},
  {
        id: 3,
        img: "https://i.postimg.cc/tJmPD2jM/E2.png",
        role: "CON-BOWLING (Concreting)",
        company: "Venue: SERC & B Block",
        date: "Time: 04:15PM to 06:15PM",
        desc: "Participants will have to cast a concrete sphere using the mix design provided and wait for 24Hr",
    },
    {
      id: 4,
      img: "https://i.postimg.cc/BvVBmSBg/E7.png",
      role: "CAREER CATALYST (Round 1)",
      company: "Venue: B-213 & B-214",
      date: "Time: 05:00PM to 06:15PM",
      desc: "Participants will go through the various placement processes like registration, aptitude test, group discussion (GD) and Interviews.",
  },
    {
        id: 5,
        img: "https://i.postimg.cc/RFxzJBJP/E5.png",
        role: "FAB-BRIDGE",
        company: "Venue: B-104 A & B",
        date: "Time: 06:15PM to 07:30PM",
        desc: "A competition of fabrication of bridge will develop the interest, in design of bridges and various types of loads acting on them, among the participants.",
    }
];

  
  export const education = [
    {
      id: 0,
      img: "https://i.postimg.cc/5N7pkSg1/E1.png",
      role: "Civil Hunt",
      company: "Venue: B Block",
      date: "Time: 09:00AM to 01:30PM",
      desc: "A technical quest for the participants that will amplify their technical knowledge. Clues will be provided to them to reach the various higher stages.",
  },
  {
    id: 1,
    img: "https://i.postimg.cc/BvVBmSBg/E7.png",
    role: "CAREER CATALYST (Round 2 & 3)",
    company: "Venue: B-213 & B-214",
    date: "Time: 10:30AM to 01:00PM",
    desc: "Participants will go through the various placement processes like registration, aptitude test, group discussion (GD) and Interviews.",
},
  {
    id: 2,
    img: "https://i.postimg.cc/qvm1MFqZ/survey.jpg",
    role: "Angle Quest",
    company: "Venue: A-B Lawn",
    date: "Time: 11:00AM to 12:30PM",
    desc: "It is a practical event where participants use surveying equipment to measure and calculate the area of a designated land parcel. ",
},
{
  id: 3,
  img: "https://i.postimg.cc/tJmPD2jM/E2.png",
  role: "CON-BOWLING (Testing)",
  company: "Venue: SERC",
  date: "Time: 02:00 PM to 04:00 PM",
  desc: "Testing of the casted spheres. Strength and rolling of the ball will be tested.",
},
{
  id: 4,
  img: "https://i.postimg.cc/RFxzJBJP/E5.png",
  role: "FAB-BRIDGE(Testing)",
  company: "Venue: B-104 A & B",
  date: "Time: 02:00PM to 04:00PM",
  desc: "Testing of the casted spheres. Strength and rolling of the ball will be tested.",
},
{
  id: 5,
  img: "https://i.postimg.cc/PrQbBzMN/E8.png",
  role: "CIVISTA",
  company: "Venue: C-Audi",
  date: "Time: 03:00PM to 08:00PM",
  desc: "Civista is a technical talent showcase designed to uncover and nurture the next generation of tech innovators. ",
},
  ];
  
  export const projects = [
    {
      id: 3,
      title: "ARFF Mock Drill",
      category:"web app",
      description:
        "Awareness regarding fire safety will be provided and a mock drill will be organized for the same.This is fire mockdrill open to all no need of registration.",
        
      image:
        "https://i.postimg.cc/s29hbVzS/E3.png",
      tags: ["HTML", "Bootstrap", "JavaScript", "Tailwind CSS"],
      github: "https://github.com/zalabhavy/blogofmine",
      // webapp: "https://bhavyzalablogwebsite.netlify.app/",
    },
    {
      id: 0,
      title: "Civil Hunt",
      
      category:"web app",
      description:
        "Knack Chase is an exciting tech quest where teams solve engineering puzzles, technical challenges, and cryptic clues to progress from one location to the next. Combining the thrill of a treasure hunt with problem-solving, the goal is to decrypt clues and reach the final treasure. The team that completes the quest in the shortest time wins.",
      image:
        "https://i.postimg.cc/5N7pkSg1/E1.png",
      tags: ["HTML", "CSS", "JavaScript", "Weather-API"],
      github: "https://github.com/zalabhavy/weatherweb",
      webapp: "https://docs.google.com/forms/d/e/1FAIpQLSd6t-VjLUTDgLF0juegRHOF-rQY5ngwsAB51LUtBXW6FmOCHw/viewform?usp=sf_link",
    },
    {
        id: 1,
        title: "Con-Bowling",
        
        category:"web app",
        description:
          "The goal is to cast concrete spheres with the molds as well as the mix design provided. Spheres will be tested after 24 hours of casting i.e. the next day. The testing shall be carried out in form of some physical parameters and some fun games carried out with bowling.",
        image:
          "https://i.postimg.cc/tJmPD2jM/E2.png",
        tags: ["HTML", "Bootstrap", "JavaScript"],
        github: "https://github.com/zalabhavy/todolist1",
        webapp: "https://docs.google.com/forms/d/e/1FAIpQLSfoSA7H0I9KlJ0RjiZsAeFIKzlo8dDhQ-mkOj8PJvi-f1rAiA/viewform?usp=sf_link",
      },
      {
        id: 3,
        title: "Fab-Bridge",
        
        category:"front end",
        description:
        "Through hands-on experience, participants will engage with the practical aspects of constructing a bridge, allowing them to explore the intricacies of design, material selection, and structural integrity.The competition also highlights the importance of various types of loads that a bridge must withstand, such as weight, wind, and dynamic forces, providing participants with a comprehensive view of real-world engineering challenges. By actively participating in the design and construction process, competitors will not only enhance their technical skills but also foster a genuine interest in the field of civil engineering, laying a strong foundation for future endeavors in the discipline.",
        image:
        "https://i.postimg.cc/RFxzJBJP/E5.png",
        tags: ["React", "CSS" ],
        github: "https://github.com/zalabhavy/React_page",
        webapp: "https://forms.gle/pNDfrDFVekHBj6faA",
      },
      {
        id: 4,
        title: "Angle Quest",
        
        category:"front end",
        description:
          "It is a practical event where participants use surveying equipment to measure and calculate the area of a designated land parcel. They establish control points, measure distances and angles, and record data to determine the area using appropriate formulas. The competition assesses participants' knowledge, skills, and efficiency in land surveying techniques.",
        image:
          "https://i.postimg.cc/qvm1MFqZ/survey.jpg",
        tags: ["HTML", "Tailwind CSS" ],
        github: "https://github.com/zalabhavy/Microsoft-responsive-clone",
        webapp: "https://docs.google.com/forms/d/e/1FAIpQLSdzdh1Y4zfRQ4CQ074LcAeGxqKFuvWigLeaR64lucxfAU8yGA/viewform?usp=sf_link",
      },
      {
        id: 5,
        title: "Quiz Whiz",
        
        category:"front end",
        description:
          "This event is a fantastic opportunity to test your knowledge, engage with peers, and showcase your skills in civil engineering. Participants will have the chance to win exciting prizes while deepening their understanding of key concepts in the field.",
        image:
          "images/quiz.png",
        tags: ["React", "CSS" ],
        github: "https://github.com/zalabhavy/React_page",
        webapp: "https://forms.gle/wus7EgQ83TXo1ejr8",
      },
      {
        id: 6,
        title: "Career-Catalyst",
        
        category:"front end",
        description:
          "Career Catalyst is an intensive placement preparation event designed to equip participants with essential skills and knowledge for successful job placement. The event comprises three main rounds: Aptitude Test, Group Discussion (GD), and Interviews.",
        image:
          "https://i.postimg.cc/BvVBmSBg/E7.png",
        tags: ["React", "CSS" ],
        github: "https://github.com/zalabhavy/React_page",
        webapp: "https://docs.google.com/forms/d/129O3OFRb5e34M7-l6axlp4dNaZMFbJZJiOYI7XQOejQ/edit",
      },
      {
        id: 7,
        title: "CIVISTA",
        
        category:"front end",
        description:
          "Civista is a competitive event designed to test the technical knowledge and problem-solving skills of engineering students. Participants will work in teams to tackle real-world engineering challenges, ranging from structural design to material selection and resource management. The competition will include a series of tasks that require innovative thinking and practical application of engineering principles. Teams will be judged on their creativity, efficiency, and ability to work collaboratively under time constraints.The event aims to provide students with hands-on experience in engineering problem-solving, while also encouraging teamwork and communication.",
        image:
          "https://i.postimg.cc/PrQbBzMN/E8.png",
        tags: ["React", "CSS" ],
        github: "https://github.com/zalabhavy/React_page",
        webapp: "https://forms.gle/FUbn6LQAmLqTDo6b9",
      }
  ];
  export const TimeLineData = [
    { year: 2022, text: "Problem Solving" },
    { year: 2023, text: "DSA and Web Development" },
    { year: 2024, text: "Open Source and DBMS" },
  ];